module.exports = __webpack_public_path__ + "img/osint-logo-pure.60069b27.png";